import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { TalentHero } from "./hero";
import { SuiteSection } from "./suite";
import { WhyChooseSuite } from "./whyChooseSuite";
import { ExploreModules } from "./modules";
import { TalentCta } from "./cta";
import { SuiteTab } from "./shared";

const TalentEnablementUI = () => {
  const [params, setParams] = useSearchParams();

  // Tab lives in the URL so a view can be linked to and survives a refresh.
  const tab: SuiteTab = params.get("tab") === "partner" ? "partner" : "toolkit";

  const setTab = (next: SuiteTab) => {
    params.set("tab", next);
    setParams(params, { replace: true });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 1000,
      offset: 100,
      easing: "ease-in-out",
      once: true,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [tab]);

  return (
    <div className="bg-white overflow-x-hidden">
      <TalentHero />
      <SuiteSection tab={tab} onTabChange={setTab} />
      {tab === "toolkit" && (
        <>
          <WhyChooseSuite />
          <ExploreModules />
        </>
      )}
      <TalentCta />
    </div>
  );
};

export { TalentEnablementUI };
export { TalentPreviewUI } from "./preview";
